import React, { Component, useCallback, useEffect, useRef, useState } from "react";

import { createPortal } from "react-dom";

class TooltipErrorBoundary extends Component {
    constructor (props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError () {
        return { hasError: true };
    }

    componentDidCatch (error) {
        const message = error instanceof Error ? error.message : String(error);
        if (
            message.includes("The target") ||
            message.includes("Failed to execute 'querySelectorAll'") ||
            message.includes("Invalid selector")
        ) {
            return;
        }
        console.error("Unhandled Error:", error);
    }

    render () {
        if (this.state.hasError) return null;
        return this.props.children;
    }
}

const CustomTooltip = (props) => {

    const { target, content, className = "" } = props;
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const tooltipRef = useRef(null);

    const updatePosition = useCallback(() => {
        const targetEl = document.getElementById(target);
        if (!targetEl) return;
        const rect = targetEl.getBoundingClientRect();
        setPosition({
            top : rect.top + window.scrollY,
            left: (rect.left + (rect.width / 2)) + window.scrollX
        });
    }, [target]);

    useEffect(() => {
        const targetEl = document.getElementById(target);
        if (!targetEl) return;

        const show = () => {
            updatePosition();
            setTooltipOpen(true);
        };
        const hide = () => setTooltipOpen(false);

        targetEl.addEventListener("mouseenter", show);
        targetEl.addEventListener("mouseleave", hide);
        targetEl.addEventListener("focus", show);
        targetEl.addEventListener("blur", hide);

        return () => {
            targetEl.removeEventListener("mouseenter", show);
            targetEl.removeEventListener("mouseleave", hide);
            targetEl.removeEventListener("focus", show);
            targetEl.removeEventListener("blur", hide);
        };
    }, [target, updatePosition]);

    return (
        <TooltipErrorBoundary>
            {tooltipOpen && createPortal(
                <div
                    ref={tooltipRef}
                    className={`-translate-x-1/2 -translate-y-full absolute z-[1080] ${className}`}
                    role="tooltip"
                    style={{
                        position: "absolute",
                        top     : position.top,
                        left    : position.left
                    }}>
                    <div className="relative rounded bg-dark px-2 py-1 text-xs text-white shadow-md">
                        {content}
                        <div className="absolute left-1/2 top-full h-2 w-2 -translate-x-1/2 -translate-y-1/2 rotate-45 bg-dark" />
                    </div>
                </div>,
                document.body
            )}
        </TooltipErrorBoundary>
    );

};

export default CustomTooltip;